
import { defineComponent } from 'vue'
import AsahiTypography from '@/components/library/Typography.vue'
import AsahiButton from '@/components/library/AsahiButton.vue'

export default defineComponent({
  name: 'ConfirmModal',

  components: {
    AsahiButton,
    AsahiTypography
  },

  emits: ['confirm', 'cancel'],

  props: {
    title: String,
    message: String,
    icon: String,
    cancel: String,
    confirm: {
      type: String,
      default: 'OK'
    },
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  },

  methods: {
    onConfirm () {
      this.$emit('confirm')
      this.closeModal()
    },
    onCancel () {
      this.$emit('cancel')
      this.closeModal()
    }
  }
})
